export default __webpack_public_path__ + "static/media/Carburetors.611ab2c4.jpg";